export default "__VITE_ASSET__DvPBpKPe__"